(function (root, factory) {
        if (typeof define === 'function' && define.amd) {
            // AMD. Register as an anonymous module.
            define([], factory);
        } else if (typeof module === 'object' && module.exports) {
            // Node. Does not work with strict CommonJS, but
            // only CommonJS-like environments that support module.exports,
            // like Node.
            module.exports = factory();
        } else {
            // Browser globals (root is window)
            root.returnExports = factory();
        }
    }(typeof self !== 'undefined' ? self : this, function () {
        // Just return a value to define the module export.
        // This example returns an object, but the module
        // can return a function as the exported value.
        'use strict';
        var skins = {};
         skins['skins.viewer.itunesbutton.ItunesButtonSkin'] = {
  "react": [
    [
      "div",
      "downloadButton",
      [],
      {},
      [
        "img",
        "itunesImg",
        [],
        {
          "src": "",
          "alt": ""
        }
      ]
    ]
  ],
  "css": {
    "%": "cursor:pointer;min-height:40px;min-width:110px;max-width:400px;max-height:145px;",
    "%itunesImg": "width:100%;height:100%;",
    "% a": "display:block;height:100%;"
  }
}

        return skins;
    }));